export default "__VITE_ASSET__EyoJ1gHp__"